import { render, staticRenderFns } from "./HotelsComponent.vue?vue&type=template&id=5ffa5913&scoped=true"
import script from "./HotelsComponent.vue?vue&type=script&lang=js"
export * from "./HotelsComponent.vue?vue&type=script&lang=js"
import style0 from "./HotelsComponent.vue?vue&type=style&index=0&id=5ffa5913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa5913",
  null
  
)

export default component.exports